module.exports = __webpack_public_path__ + "img/urgent-notice.bc1e0185.svg";